import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import './style.css'
import LoadingOverlay from '../loading/loading';
import service from '../../services/service';

const Rule = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getInformation();
    }, []);

    const getInformation = async () => {
        try {
            setLoading(true);
            const response = await service.view("information");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            setData(response.information)
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="wpo-about-area section-padding">
            {loading && <LoadingOverlay />}
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-section-title">
                                <span>Rules</span>
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: data?.rules }} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Rule;